import { useEffect, useState } from 'react';
import Ajv from 'ajv';
import useSchemaForDataElement from './useSchemaForDataElement';
import addFormats from '@/utils/custom-ajv-formats';
import { ajvErrorMapping } from '@/utils/ajv-error-mapping/index';

const ajv = new Ajv({ allErrors: true, verbose: true });
addFormats(ajv);

/**
 * Owns submittal form state: schema, payload, validation, and the AJV-derived
 * error list shown in the floating panel. Schema/payload loading is delegated
 * to `useSchemaForDataElement`; this hook layers validation on top.
 *
 * Re-runs validation whenever `payload` changes.
 */
const useSubmittalForm = ({ selectedDataElement, existingSubmittal }) => {
    const { schema, payload, setPayload, isDirty, setIsDirty } = useSchemaForDataElement({
        dataElementId: selectedDataElement?.id,
        existingPayload: existingSubmittal?.payload || null,
    });

    const [isValidFormat, setIsValidFormat] = useState(true);
    const [errorListToDisplay, setErrorListToDisplay] = useState([]);
    const [isSubmitClicked, setIsSubmitClicked] = useState(false);

    useEffect(() => {
        if (payload && schema) {
            validateSchema();
            validateErrors();
        }
    }, [payload]);

    function validateSchema() {
        const validate = ajv.compile(schema);
        const isPayloadValid = validate(payload);
        return isValidFormat && isPayloadValid;
    }

    function validateErrors() {
        const validate = ajv.compile(schema);
        const errorMessages = ajvErrorMapping(validate.errors, schema, payload, { isSubmittalsEnabled: true, fieldLineNumbers: {} });
        setErrorListToDisplay(errorMessages);
    }

    return {
        schema,
        payload,
        setPayload,
        isDirty,
        setIsDirty,
        isValidFormat,
        setIsValidFormat,
        errorListToDisplay,
        isSubmitClicked,
        setIsSubmitClicked,
        validateSchema,
        validateErrors,
    };
};

export default useSubmittalForm;
